import { useState, useEffect } from 'react';
import { loadAllPartnerFeeds } from '@/lib/partnerFeeds';
import { setPartnerBooks } from '@/lib/partnerBooks';

/**
 * Hook pour charger les flux partenaires au démarrage de l'application.
 * Les données sont mises en cache dans localStorage (TTL 60 min).
 * En cas d'échec, le fallback statique est utilisé automatiquement.
 */
export function usePartnerBooks() {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [bookCount, setBookCount] = useState(0);

  useEffect(() => {
    loadAllPartnerFeeds()
      .then(books => {
        if (books.length > 0) {
          setPartnerBooks(books);
          setBookCount(books.length);
        }
        // Si aucun livre chargé, getPartnerBooks() retournera le fallback
      })
      .catch(err => {
        console.error('[usePartnerBooks] Error:', err);
        setError(err instanceof Error ? err.message : 'Unknown error');
      })
      .finally(() => setIsLoading(false));
  }, []);

  return { isLoading, error, bookCount };
}
